import * as React from "react";
import { Dispatch } from "redux";
import { connect } from "react-redux";
import { ApplicationState }  from "src/store/index";
import { FormComponentProps } from "antd/lib/form";
import { Icon, Card, Form, Row, DatePicker, Upload, Button, message, Input} from "antd";
import { LoadingType, PayType } from "src/store/pay/types";
import { fetchLoading, fetchDownLoadTemp } from "src/store/pay/actions";
import { LOGIN_URL, TOKEN, CID, LOCALHOST, ONE_M } from "src/common/constants";
import MsModal from "src/components/ms-common/ms-modal/MsModal";
import MsBreadcrumb from "src/components/ms-common/ms-breadcrumb/MsBreadcrumb";
import Tools from "src/utils/tools";
import "./MsNewPay.scss";

interface PropsFromState extends FormComponentProps {
  loading: LoadingType;
  onePay: PayType;
}

interface PropsFromDispatch {
  loadingDisp: typeof fetchLoading;
  downLoadDisp: typeof fetchDownLoadTemp;
}

interface PropsOwn {
  goBack: () => void;
  save: (data: any) => void;
}

type AllProps = PropsFromState & PropsFromDispatch & PropsOwn;

const mapStateToProps = ({payState}: ApplicationState) => ({
  loading: payState.loading,
  onePay: payState.onePay
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  loadingDisp: (data: LoadingType) => dispatch(fetchLoading(data)),
  downLoadDisp: (data: any) => dispatch(fetchDownLoadTemp(data)),
})

const breadList = [
  {code: "1", text: "收入发放"},
  {code: "2", text: "创建发放"},
];

const FormItem = Form.Item;

const url = "salaryCpayCp/income/uploadIncomeFile";

class MsNewPay extends React.Component<AllProps> {

  /**
   * 检查长度，写在render中太长，所以抽出来写个函数
   */
  public onCheckLength = () => {
    const length = this.props.form.getFieldValue("remark").length;
    return length <= 200;
  }
  /**
   * 提交
   */
  public onSubmit = (e: any) => {
    e.preventDefault();
    this.props.form.validateFields((err: any, values: any) => {
      if (err) {
        if (!values.specifyPayDate) {
          MsModal.error({content: "请选择发放时间"});
        } 
      } else {
        const num = 999999999999.99;
        if (values.totalAmount <= 0) {
          MsModal.error({content: "发放总额必须大于0，请重新选择名单上传"});
          return;
        }
        if (values.totalAmount > num) {
          MsModal.error({content: `发放总额最大${num}，请重新选择名单上传`});
          return;
        }
        const specifyPayDate = Tools.formatTime(values.specifyPayDate, true);
        values = {
          ...values,
          specifyPayDate
        }
        this.props.save(values);
      }
    });
  }
  /**
   * 设置不可选的日期
   * @param   value   当前日期控件显示的每个日期
   */
  public onSetDisabledEndDate = (value: any) => {
    return value <= new Date(Tools.formatTime(new Date().getTime(), false)).getTime();
  }
  /**
   * 金额转中文
   * 勿删！！！测试用
   */
  public onTransNumberToCH = () => {
    const num = this.props.form.getFieldValue("testTotal");
    if (!num.trim()) {
      return;
    }
    if (num.substr(num.length - 1) === ".") {
      message.error("请输入完整的数字");
      return;
    }
    if (isNaN(num)) {
      message.error("请输入数字，最大999999999999.99");
      return;
    }
    if (+num > 999999999999.99) {
      message.error("最大999999999999.99");
      return;
    }
    const numCH = Tools.transNumberToCH(num);
    this.props.form.setFieldsValue({showTotal: numCH});
  }

  public onDownLoad = () => {
    this.props.downLoadDisp({data: {bizLine: 1}, fileName: this.props.onePay.fileName});
  }
  /**
   * 上传文件
   * @param   limitSize   限制文件大小
   */
  public uploadFile = (limitSize: number) => {
    return (info: any) => {
      const status = info.file.status;
      if (status === "uploading") {
        this.props.loadingDisp({showA: true, text: "正在上传，请稍后..."})
      }
      if (status === 'done') {
        this.props.loadingDisp({showA: false, text: ""});
        const res = info.file.response;
        if (res) {
          if (info.file.size > limitSize * ONE_M) {
            MsModal.error({content: `最大上传${limitSize}M的文件`});
            return;
          }
          if (res.result !== 0) {
            res.result === 401
            ? MsModal.error({content: "登陆已过期，请重新登陆！", onOk: () => {
                Tools.delCookie("ms_member_token");
                Tools.delCookie("ms_cid");
                location.href = LOGIN_URL;
              }})
            : MsModal.error({content: res.detail});
          } else {
            this.onGetUploadResult(res, info.file.name);
          }
        } else {
          MsModal.error({content: "上传文件失败"});
        }
      } else if (status === 'error') {
        this.props.loadingDisp({showA: false, text: ""})
        MsModal.error({content: "上传文件错误"});
      }
    }
  }
  /**
   * 上传后的返回，显示总金额和笔数
   * @param   res              返回数据
   * @param   uploadFileName   文件名
   */
  public onGetUploadResult = (res: any, uploadFileName: string) => {
    const { totalAmount, totalNum } = res.data;
    this.props.form.setFieldsValue({
      totalAmount,
      totalNum,
      uploadFileName
    })
  }

  public render() {
    const { batchNo, bizLine, dataSource } = this.props.onePay
    const uploadParam = {
      batchNo,
      bizLine,
      cid: CID,
      token: TOKEN,
      totalAmount: "",
      totalNum: ""
    }
    const action = `${ LOCALHOST }/${ url }`;
    const uploadProps = {
      name: "file",
      action,
      data: uploadParam,
      onChange: this.uploadFile(100),
      showUploadList: false
    };
    const { getFieldDecorator } = this.props.form;
    return (
      <div className="pay-new">
        <div className="pay-new-title">
            <div className="div-bread">
              <MsBreadcrumb list={breadList} />
            </div>
            <a className="div-return" href="javascript:;" onClick={this.props.goBack}>
              <Icon type="left" />返回
            </a>
        </div>
        <Card className="card-form">
          <Form className="pay-new-form">
            <Row className="row-pay-date">
              <FormItem label="发放时间" colon={false}>
                {getFieldDecorator("specifyPayDate", {
                  rules: [
                    {required: true}
                  ]
                })(
                  <DatePicker
                    className="pay-date"
                    disabledDate={this.onSetDisabledEndDate}
                  />
                )}
                <span className="tip">为保障发放正常，请在发放时间前3个工作日创建完任务，并在发放时间中午12点之前付款。</span>
              </FormItem>
            </Row> 
            <Row>
              <label className="upload-label">发放名单</label>
              <Upload {...uploadProps} className="upload-btn">
                <Button>上传文件</Button>
              </Upload>
              <a href="javascript:;" className="div-a" onClick={this.onDownLoad}>模板下载</a>
              <span className="tip">(如用自己模板则表格中必须包含以下字段：{this.props.onePay.tempFields})</span>
              <div className="div-ext">
                <FormItem>
                  {getFieldDecorator("uploadFileName", {
                    initialValue: ""
                  })(
                      <span className={`upload-file-name ${!this.props.form.getFieldValue("uploadFileName") ? "" : "mr-20"}`} title={this.props.form.getFieldValue("uploadFileName")}><Icon type="paper-clip" />{this.props.form.getFieldValue("uploadFileName")}</span>
                    )
                  }
                </FormItem>
                <span>支持扩展名：.CSV 最大上传5000条数据</span>
              </div>
            </Row>
            <Row className="row-pay pay-total">
              <FormItem label="发放总额" colon={false} style={{float: "left", width: 700}}>
                {getFieldDecorator("totalAmount", {
                  initialValue: 0
                })(
                    <span>
                      {Tools.thousandSeparator(this.props.form.getFieldValue("totalAmount"))}元
                      {+this.props.form.getFieldValue("totalAmount") ? `(${Tools.transNumberToCH((+this.props.form.getFieldValue("totalAmount")).toFixed(2))})` : ""}  
                    </span>
                  )
                }
              </FormItem>
            </Row>
            <Row className="pay-count">
              <FormItem label="发放笔数" colon={false}>
                {getFieldDecorator("totalNum", {
                  initialValue: 0
                })(
                    <span>{this.props.form.getFieldValue("totalNum")}<span>笔</span></span>
                  )
                }
              </FormItem>
            </Row>
            <Row className="row-pay remark">
              <FormItem label="发放备注" colon={false}>
              {getFieldDecorator('remark', {
                  initialValue: "",
                })(
                  <Input.TextArea placeholder="请输入备注" maxLength={16} />
                )}
                <div className="show-length">
                  <span className={`${!this.onCheckLength() ? "font-red" : ""}`}>
                    {this.props.form.getFieldValue("remark").length}
                  </span>
                  /最多16字符
                </div>
              </FormItem>
              <FormItem>
                {getFieldDecorator("batchNo", {
                  initialValue: batchNo
                })( <span /> )
                }
              </FormItem>
              <FormItem>
                {getFieldDecorator("bizLine", {
                  initialValue: bizLine
                })( <span /> )
                }
              </FormItem>
              <FormItem>
                {getFieldDecorator("dataSource", {
                  initialValue: dataSource
                })( <span /> )
                }
              </FormItem>
            </Row>
            <Row className="row-submit">
              <FormItem>
                <Button type="default" onClick={this.props.goBack}>取消</Button>
                <Button type="primary" onClick={this.onSubmit}>发布</Button>
              </FormItem>
            </Row>
          </Form>
        </Card>
      </div>
    )
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(MsNewPay));

/* 勿删，测试金额转大写，将下面代码放入form中
<FormItem colon={false} style={{ float: "left" }}>
  {getFieldDecorator("testTotal", {
    initialValue: ""
  })(
    <div>
      <Input autoComplete="off" style={{ width: 200 }} placeholder="输入金额，按回车转换" onPressEnter={this.onTransNumberToCH} />
    </div>
  )
  }
</FormItem>
  <FormItem style={{ width: 400, float: "left", height: 30, position: "absolute", top: 28, left: 700 }}>
    {getFieldDecorator("showTotal", {
      initialValue: ""
    })(
      <span>{this.props.form.getFieldValue("showTotal")}</span>
    )
    }
  </FormItem>
*/



// WEBPACK FOOTER //
// ./src/components/ms-pay/ms-new-pay/MsNewPay.tsx